import { render, staticRenderFns } from "./FormRatingBar.vue?vue&type=template&id=509f1aa5&scoped=true&"
import script from "./FormRatingBar.vue?vue&type=script&lang=js&"
export * from "./FormRatingBar.vue?vue&type=script&lang=js&"
import style0 from "./FormRatingBar.vue?vue&type=style&index=0&id=509f1aa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f1aa5",
  null
  
)

export default component.exports